var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 300,
    viewBox: "0 0 301 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6496_24262)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6496_24262",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 301,
    height: 300
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.5 0H0.5V300H300.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6496_24262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.176 106.013C276.528 58.5809 196.196 -45.5511 91.9519 29.2089C68.3199 46.1489 53.8439 68.3529 47.2639 139.305C45.4439 158.989 35.3919 176.909 23.4079 211.489C16.6599 230.921 15.5399 277.401 53.1999 288.852C102.956 304 165.34 295.348 195.328 280.621C233.492 261.889 290.22 198.413 281.176 106.013Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4729 254.211L37.4506 142.903C36.3326 137.287 40.6487 132.035 46.3687 132.035H197.769C202.111 132.035 205.855 135.103 206.687 139.367L228.709 250.675C229.827 256.291 225.511 261.543 219.791 261.543H68.391C64.049 261.543 60.3049 258.475 59.4729 254.211Z",
    fill: "#123D1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.737 261.399L270.015 260.851L270.526 270.42L274.779 270.193L274.268 260.624L284.547 260.075L284.32 255.822L274.041 256.37L273.531 246.801L269.277 247.028L269.788 256.598L259.51 257.146L259.737 261.399Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.502 32.3529L269.687 33.4835L268.634 42.966L272.849 43.4338L273.901 33.9514L284.086 35.082L284.554 30.8676L274.369 29.737L275.422 20.2545L271.208 19.7867L270.155 29.2691L259.97 28.1385L259.502 32.3529Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4401 93.7825C17.5159 93.7825 12.7051 88.9716 12.7051 83.0475C12.7051 77.1234 17.5159 72.3125 23.4401 72.3125C29.3642 72.3125 34.175 77.1234 34.175 83.0475C34.175 88.9716 29.3642 93.7825 23.4401 93.7825ZM23.4401 77.0836C20.14 77.0836 17.4762 79.7475 17.4762 83.0475C17.4762 86.3475 20.14 89.0114 23.4401 89.0114C26.7401 89.0114 29.4039 86.3475 29.4039 83.0475C29.4039 79.7475 26.7401 77.0836 23.4401 77.0836Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7366 248.932L99.6691 160.323C101.073 156.891 104.401 154.629 108.093 154.629H258.401C264.849 154.629 269.269 161.155 266.825 167.135L230.893 255.744C229.489 259.176 226.161 261.438 222.469 261.438H72.1608C65.7127 261.438 61.3186 254.912 63.7366 248.932Z",
    fill: "#00A656"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6496_24262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImage);
export default __webpack_public_path__ + "static/media/fileImage.bf97cfa800a2cdf442519e147821bb74.svg";
export { ForwardRef as ReactComponent };